<div class="content">
  <form
    class="form"
    [formGroup]="productPackageFormGroup()"
  >
    @for (row of productPackageFormComponents; track $index) {
      @if (getFormFields(row).length > 0) {
        <div [class]="getRowClass(row)">
          @for (field of getFormFields(row); track $index) {
            @switch (field.type) {
              @case ('number') {
                <mat-form-field
                  appearance="outline"
                  class="form-field"
                  [class]="getFieldClass()"
                >
                  <mat-label>{{ field.label }}</mat-label>
                  <input
                    #inputElement
                    matInput
                    appDecimalLimit
                    [decimals]="field.decimals || 0"
                    [type]="field.type"
                    inputmode="decimal"
                    [formControlName]="field.fieldName"
                    (blur)="handleValueChange(field.fieldName, inputElement.value)"
                  >
                  @if (field.matTextSuffixValue) {
                    <span matTextSuffix>
                    {{ field.matTextSuffixValue }}
                  </span>
                  }
                </mat-form-field>
              }
              @case ('text') {
                <mat-form-field
                  appearance="outline"
                  class="form-field"
                  [class]="getFieldClass()"
                >
                  <mat-label>{{ field.label }}</mat-label>
                  <input
                    matInput
                    [type]="field.type"
                    [formControlName]="field.fieldName"
                    (blur)="handleValueChange(field.fieldName)"
                  >
                </mat-form-field>
              }
              @case ('select') {
                @if (getSelectData(field.fieldName).length) {
                  <app-custom-mat-select
                    [label]="field.label"
                    [options]="getSelectData(field.fieldName)"
                    [selectedValueId]="getSelectedValue(field.fieldName)"
                    [isEditModeActive]="getEditModeForSelect()"
                    [needEmptyValue]="false"
                    [fullWidth]="true"
                    (selectedChange)="handleSelectChange($event, field.fieldName)"
                  />
                }
              }
              @case ('textarea') {
                <mat-form-field
                  appearance="outline"
                  class="form-field"
                  [class]="getFieldClass()"
                >
                  <mat-label>{{ field.label }}</mat-label>
                  <textarea
                    matInput
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="7"
                    cdkAutosizeMaxRows="7"
                    placeholder="Введите комментарий"
                    [formControlName]="field.fieldName"
                    (blur)="handleValueChange(field.fieldName)"
                  ></textarea>
                </mat-form-field>
              }
            }
          }
        </div>
      }
    }
  </form>
  @if (!productPackageData().id) {
    <div class="buttons-container">
      @if (noFirstData()) {
        <button
          mat-button
          color="warn"
          type="button"
          (click)="handelDelete()"
        >
          Удалить
        </button>
      }
      <button
        mat-button
        color="primary"
        type="button"
        [disabled]="!productPackageFormGroup().valid"
        (click)="handelCreate()"
      >
        Сохранить
      </button>
    </div>
  }
</div>
